"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedStatement = exports.getStatements = void 0;
const permissions_1 = require("shared/permissions");
const endpoint_1 = require("api/endpoint");
exports.getStatements = endpoint_1.createEndpoint()({
    method: "post",
    path: "billing/statements",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.getSelectedStatement = endpoint_1.createEndpoint()({
    method: "post",
    path: "billing/selectedstatement",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});



//////////////////
// WEBPACK FOOTER
// ./src/api/billing/billing-client.ts
// module id = 981
// module chunks = 0 1 2